import Auth from '@aws-amplify/auth'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from './slice'

export const useAuth = () => {
  const dispatch = useDispatch()
  const state = useSelector(state => state.auth)

  const signOut = async () => {
    await Auth.signOut()
    window.location.replace('/')
  }

  const userType = state.user && state.user.organisation.type

  const hasPermission = permission => {
    return userType === 'buyer'
      ? state.user.role.permissions.some(p => p.name === permission)
      : false
  }

  const hasEnvironments =
    userType === 'buyer' ? state.user.environments.length > 0 : false

  return {
    ...bindActionCreators(actions, dispatch),
    ...state,
    hasEnvironments,
    hasPermission,
    loggedIn: !!state.user,
    userType,
    signOut,
  }
}
